/**
 * Default entity ATIs for Focus/Mercury (1P).
 */
import type { MercuryEntityATI } from '@atlassian/search-client/common/types';

export type ReadonlyMercuryEntityATI = readonly MercuryEntityATI[];

export const DEFAULT_FOCUS_ENTITY_ATI: ReadonlyMercuryEntityATI = [
	'ati:cloud:mercury:focus-area',
	'ati:cloud:mercury:focus-area-status-update',
];
